export default __webpack_public_path__ + "static/media/pakistan-flag.ad6b188e.svg";